<template>
  <ModalPagoFactura
    v-if="allowCreateBills"
    v-model:isOpen="isOpen"
    :data="billToEdit"
    :client-id="clientId"
    @succes="getBalance(true)"
  />
  <ModalAddInvoice
    v-model:active="isAddInvoiceActive"
    :loading="isLoading.add"
    @create-invoice="handleInvoiceAction($event)"
  />
  <ModalPayInvoice
    v-model:active="isPayInvoiceActive"
    :data="invoiceData"
    :loading="isLoading.pay"
    @pay-invoice="handlePayInvoice($event)"
  />
  <ModalConfirmDeleteInvoice
    v-model:active="isDeleteModalActive"
    :data="invoiceData"
    :loading="isLoading.delete"
    @delete="handleDeleteInvoice($event)"
  />
  <header class="header-bills">
    <Tag v-if="!isClient" class="tag-name" size="large" variant="bluehues">
      <span>Cliente:</span>
      <o-icon v-if="isLoading.client" icon="loading" spin size="small" class="mx-3" />
      <span v-else class="ml-2 has-text-weight-bold">{{ clientData.name }}</span>
    </Tag>
    <div class="container-info is-flex">
      <Tag class="tag-balance" size="large">
        <span>Honorarios pendientes: </span>
        <o-icon v-if="isLoading.balance" icon="loading" spin size="small" class="mx-3" />
        <span v-else :class="`ml-2 has-text-weight-bold ${tagBalance.color}`">
          {{ tagBalance.value }}
        </span>
      </Tag>
      <Field
        v-model="fieldSearch.value"
        class="field-search"
        placeholder="Buscar"
        icon-right="magnify"
        text-transform="upper"
      >
        <template #addonsLeft>
          <Dropdown
            v-model:selected="itemSelected"
            label="Campos de búsqueda"
            variant="info"
            :data="dropdownItems"
          />
        </template>
      </Field>
      <o-tooltip
        :active="Boolean(!clientData.is_active_bills && clientData.length)"
        label="Cliente con facturación deshabilitada"
        variant="black"
      >
        <Button
          v-if="allowCreateBills"
          class="add-button"
          variant="primary"
          icon-left="plus"
          label="Nueva factura"
          :disabled="Boolean(!clientData.is_active_bills || isLoading.client)"
          @click="onAddInvoice()"
        />
      </o-tooltip>
    </div>
  </header>
  <Table
    id="table-bills-cliente"
    ref="tableBillsClient"
    v-model:loading="isLoading.data"
    :api-url="apiUrl"
    :focusable="false"
    :params="params"
    paginated
  >
    <o-table-column
      v-slot="{ row }"
      width="109"
      sortable
      label="Fecha de facturación"
      field="created_at"
      sort-icon-size="large"
    >
      <p class="is-uppercase has-text-centered">
        {{ dateFormat(row.created_at) }}
      </p>
    </o-table-column>
    <o-table-column
      v-slot="{ row }"
      width="109"
      sortable
      label="Folio"
      field="folio"
      sort-icon-size="large"
    >
      <p class="is-uppercase has-text-centered">
        {{ row.folio ?? '-' }}
      </p>
    </o-table-column>
    <o-table-column
      v-slot="{ row }"
      width="666"
      sortable
      label="Descripción"
      field="description"
      sort-icon-size="large"
    >
      <p class="is-uppercase">
        {{ row.description }}
      </p>
    </o-table-column>
    <o-table-column v-slot="{ row }" width="50" label="Monto" field="name">
      <div class="is-flex is-align-items-center is-flex-direction-column">
        <p class="is-uppercase has-text-centered mr-1">
          {{ dollarFormater(row.charge) }}
        </p>
        <Tag
          :label="isPaid(row) ? 'PAGADO' : 'PENDIENTE'"
          :variant="isPaid(row) ? 'success' : 'warning'"
          rounded
        />
      </div>
    </o-table-column>
    <o-table-column v-if="allowEditBills" v-slot="{ row }" label="Acciones" width="18">
      <div class="actions">
        <!-- Agregar ya que exista servicio de back para editar facturas -->
        <!-- <o-tooltip :delay="500" label="Editar factura" variant="black">
          <Button
            class="btn-edit"
            variant="primary"
            icon-left="pencil"
            @click="onAddInvoice(row)"
          />
        </o-tooltip> -->
        <o-tooltip
          v-if="!isPaid(row)"
          :delay="300"
          label="Registrar pago de factura"
          variant="black"
        >
          <Button
            class="btn-edit"
            variant="primary"
            icon-left="currency-usd"
            @click="onPayInvoice(row)"
          />
        </o-tooltip>
        <o-tooltip :delay="300" label="Borrar factura" variant="black">
          <Button
            class="btn-edit"
            variant="danger"
            icon-left="delete"
            @click="onDeleteInvoice(row)"
          />
        </o-tooltip>
      </div>
    </o-table-column>
    <o-table-column
      v-slot="{ row }"
      width="300"
      sortable
      label="Fecha de pago"
      field="description"
      sort-icon-size="large"
    >
      <p class="has-text-centered">
        {{ dateFormat(row['bills_related.due_date']) }}
      </p>
    </o-table-column>
  </Table>
</template>
<script>
import {
  ref,
  toRefs,
  watch,
  onMounted,
  computed,
  getCurrentInstance,
  reactive,
  onBeforeMount,
} from 'vue';
import { Table, Tag, Button, ModalPagoFactura, Field, Dropdown } from '@/components';
import { useComponentUtils } from '@/components/conf/composables';
import { Permissions } from '@/utils/Secure';
import { PermissionValidator } from '@/utils/Secure';
import { useRoute } from 'vue-router';
import { useBills } from '@/utils/composables';
import { useAuthStore } from '@/store';
import { userRoles } from '@/config/constants';
import moment from 'moment';
import ModalConfirmDeleteInvoice from '../modals/ModalConfirmDeleteInvoice.vue';
import { deleteBill } from '@/services/billsService';
import { useDialog } from '@/utils/composables';
import ModalAddInvoice from '../modals/ModalAddInvoice.vue';
import { createClientBill } from '@/services/clientsServices';
import ModalPayInvoice from '../modals/ModalPayInvoice.vue';

export default {
  components: {
    Button,
    Field,
    Dropdown,
    Table,
    Tag,
    ModalPagoFactura,
    ModalConfirmDeleteInvoice,
    ModalAddInvoice,
    ModalPayInvoice,
  },
  inheritAttrs: false,
  props: {
    clientId: { type: String, default: null },
    loading: { type: Boolean, default: false },
  },
  emits: ['update:loading'],
  setup(props, { emit }) {
    const { DOCUMENT_TYPE, getDocumentType } = useBills();
    const { getAUTH } = useAuthStore();
    const route = useRoute();
    const isOpen = ref(false);
    const { proxy } = getCurrentInstance();
    const Api = proxy?.Api;
    const tableBillsClient = ref(null);
    const { table, dollarFormater, fomatDateDMY, isClient } = useComponentUtils();
    const loading = toRefs(props).loading;
    const isLoading = reactive({
      data: props.loading,
      balance: false,
      client: false,
      add: false,
      pay: false,
      delete: false,
    });
    const balance = ref(NaN);
    const clientData = ref({});
    const fieldSearch = reactive({ oldValue: '', value: '', timeout: null });
    const dropdownItems = ref([
      { name: 'Folio', param: 'folio' },
      { name: 'Descripción', param: 'description' },
    ]);
    const itemSelected = ref(null);
    const billToEdit = ref(undefined);
    const isDeleteModalActive = ref(false);
    const isAddInvoiceActive = ref(false);
    const isPayInvoiceActive = ref(false);
    const invoiceData = ref('');
    const { Notify } = useDialog();

    //Methods
    const reload = async () => {
      if (tableBillsClient.value) {
        await tableBillsClient.value.reload();
      }
    };

    const getBalance = async (reloadTable = false) => {
      isLoading.balance = true;
      isLoading.data = true;
      try {
        const { data } = await Api.get(`clients/${clientUID.value}/balance`);
        balance.value = data.balance;
        if (reloadTable) await reload();
      } catch (error) {
        console.error(error);
      }
      isLoading.data = false;
      isLoading.balance = false;
    };

    const getClient = async () => {
      isLoading.client = true;
      try {
        if (getAUTH.role === userRoles.CLIENTE) {
          const { is_active_bills, full_name } = getAUTH;
          clientData.value = {
            name: full_name,
            is_active_bills,
          };
        } else {
          const { data } = await Api.get(`clients/${clientUID.value}`);
          clientData.value = data;
        }
      } catch (error) {
        console.error(error);
      }
      isLoading.client = false;
    };

    const onEditBill = (bill) => {
      billToEdit.value = bill;
      isOpen.value = true;
    };

    const dateFormat = (date) => (date ? moment(date).format('DD/MM/YYYY') : '-');

    const onAddInvoice = () => {
      isAddInvoiceActive.value = true;
    };

    const onDeleteInvoice = (data) => {
      invoiceData.value = data;
      isDeleteModalActive.value = true;
    };

    const onPayInvoice = (data) => {
      invoiceData.value = data;
      isPayInvoiceActive.value = true;
    };

    const handleDeleteInvoice = async (data) => {
      isLoading.delete = true;
      try {
        await deleteBill(data);
        Notify('success', 'Éxito', `Factura eliminada de manera exitosa`);
        await getBalance(true);
      } catch (error) {
        console.error(error);
      }
      isLoading.delete = false;
      isDeleteModalActive.value = false;
    };

    const handleInvoiceAction = async (data) => {
      const billData = { ...data, customer_id: props.clientId, document_type: 'I' };
      isLoading.add = true;
      try {
        await createClientBill(props.clientId, billData);
        Notify('success', 'Éxito', `Factura agregada de manera exitosa`);
        await getBalance(true);
      } catch (error) {
        console.error(error);
      }
      isLoading.add = false;
      isAddInvoiceActive.value = false;
    };

    const handlePayInvoice = async (data) => {
      const billData = {
        ...data,
        customer_id: props.clientId,
        document_type: 'P',
        credit: data.charge,
      };
      isLoading.pay = true;
      try {
        await createClientBill(props.clientId, billData);
        Notify('success', 'Éxito', `Registro de pago exitoso`);
        await getBalance(true);
      } catch (error) {
        console.error(error);
      }
      isLoading.pay = false;
      isPayInvoiceActive.value = false;
    };

    const isPaid = (data) => !!data.is_paid;

    //Computed
    const apiUrl = computed(() => `clients/${clientUID.value}/bills`);

    const tagBalance = computed(() => {
      let color =
        balance.value >= 0 || isNaN(balance.value) ? 'has-text-primary' : 'has-text-danger';
      return {
        color: color,
        value: dollarFormater(balance.value || 0),
      };
    });

    const clientUID = computed(() => route.params?.billsId);

    const params = computed(() => {
      const _params = ['sort=is_paid,id'];
      if (fieldSearch.oldValue.length)
        _params.push(`${itemSelected.value.param}=${fieldSearch.oldValue}`);
      return _params;
    });

    const allowCreateBills = computed(() => {
      const { Create } = Permissions.ClientsBills;
      return PermissionValidator(Create);
    });

    const allowEditBills = computed(() => {
      const { Update } = Permissions.Bills;
      return PermissionValidator(Update);
    });

    //Watchers
    watch(loading, (value) => (isLoading.data = value));

    watch(
      () => isLoading.data,
      (value) => emit('update:loading', value),
    );

    watch(
      () => fieldSearch.value,
      (value) => {
        itemSelected.value = itemSelected.value ?? dropdownItems.value[0];
        clearTimeout(fieldSearch.timeout);
        fieldSearch.timeout = setTimeout(() => (fieldSearch.oldValue = value), 500);
      },
    );

    watch(isOpen, (value) => {
      if (!value) billToEdit.value = undefined;
    });

    //Hooks
    onBeforeMount(() => {
      getClient();
    });
    onMounted(() => {
      getBalance();
      if (tableBillsClient.value) table.value = tableBillsClient.value;
    });

    return {
      // Data
      billToEdit,
      balance,
      clientData,
      DOCUMENT_TYPE,
      dropdownItems,
      fieldSearch,
      isLoading,
      isOpen,
      itemSelected,
      reload,
      table,
      tableBillsClient,
      isDeleteModalActive,
      isAddInvoiceActive,
      isPayInvoiceActive,
      invoiceData,

      // method
      onEditBill,
      dollarFormater,
      fomatDateDMY,
      getBalance,
      getDocumentType,
      dateFormat,
      onDeleteInvoice,
      onAddInvoice,
      onPayInvoice,
      handleDeleteInvoice,
      handleInvoiceAction,
      handlePayInvoice,
      isPaid,

      // computed
      apiUrl,
      allowEditBills,
      allowCreateBills,
      clientUID,
      tagBalance,
      isClient,
      params,
    };
  },
};
</script>

<style lang="sass" scoped>
.header-bills
  display: flex
  flex-direction: column
  margin-bottom: 32px
  .tag-name
    display: flex
    justify-content: flex-start
  .container-info
    flex-wrap: wrap
    justify-content: center
    .tag-balance
      width: 100%
      margin-bottom: 8px
      white-space: break-spaces
      height: fit-content
      min-height: 37px
      text-align: center
      > span:nth-child(2)
        word-break: break-all
      .has-text-primary
        color: $color-green-plus  !important
      .has-text-danger
        color: $color-radical-red !important
    .field-search
      width: 100%
      max-width: 600px
      :deep(.control) .has-addons
        .dropdown .button
          max-height: 37px
        > .control input
            height: 100%
    :deep(.add-button)
      max-height: 37px
      .button-wrapper
        align-items: center
        .icon
          width: fit-content
          margin-right: 7px
          .mdi::before
            font-size: 16px
  @include from($bp-md)
    .tag-name
      margin: 0 auto 16px auto
      width: fit-content
    .container-info
      justify-content: center
      .tag-balance
        width: fit-content
        margin-right: 8px
      .field-search
        order: 1
        margin-top: 16px
  @include from($bp-xl)
    .tag-name
      margin: 0
      margin-right: auto
      margin-bottom: 8px
      width: fit-content
      text-align: start
      > span:first-child
        display: inline

    .container-info
      align-items: center
      place-content: end
      .tag-balance
        width: fit-content
        margin-bottom: 8px
        margin-right: auto
      .field-search
        margin: 0
        margin-bottom: 8px
        order: 0
      :deep(.add-button)
        margin-left: 8px
        margin-bottom: 8px

  .header-title
    font-weight: 700
    color: $black
    font-size: $fh-md
    line-height: 28px
#table-bills-cliente
  .width-tag
    width: 89px
  :deep(.button).btn-edit
    border-radius: 3px
    height: 24px
    width: 24px
    padding: 0
    .icon
        margin: 0 !important
        .mdi::before
          font-size: 18px
  :deep(.b-table) .table-wrapper
    thead tr
      th
        padding: 13px 24px
        &:nth-child(3) span
          justify-content: left
    // tbody tr td
.actions
  display: flex
  justify-content: space-around
  margin-top: 12px
</style>
